import { render } from "./countries-table.vue?vue&type=template&id=d463c774"
import script from "./countries-table.vue?vue&type=script&lang=js"
export * from "./countries-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__